import { setPostStyleGuideTheme, setPreStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration"; // Importing nothing to trigger the side effects, which in this case adds custom reducers.
import postStyleGuideTheme from "@warthog/XDL/PostStyle";
import preStyleGuideTheme from "@warthog/XDL/PreStyle";

setPreStyleGuideTheme(preStyleGuideTheme);
setPostStyleGuideTheme(postStyleGuideTheme);
